<template>
  <b-row>
    <!-- Modal Export Import RH -->
    <b-modal
      v-model="showModalImport"
      title="Import Data"
      ok-title="Submit"
      @ok="handleImport"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i
          class="fa fa-times cursor-pointer"
          @click="showModalImport = false"
        ></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          variant="outline-primary"
          class="mt-3 w-100"
          @click="handleExportTemplate"
        >
          <i class="fa fa-download"></i>
          Download Template
        </b-button>
      </template>
    </b-modal>
    <!-- End Modal Export Import RH -->

    <!-- Modal Import Errors -->
    <b-modal
      v-model="showModalImportErrors"
      title="Import Errors"
      ok-only
      size="lg"
    >
      <template #modal-header>
        <h5 class="text-danger">Import Failed - Error Details</h5>
        <i
          class="fa fa-times cursor-pointer"
          @click="showModalImportErrors = false"
        ></i>
      </template>
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <thead class="thead-light">
            <tr>
              <th style="width: 100px">Row #</th>
              <th>Error Message</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(error, index) in importErrors" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ error }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <!-- End Modal Import Errors -->

    <b-col sm="12">
      <iq-card>
        <template v-slot:headerTitle>
          <h4 class="card-title text-primary">
            <strong>Master Equipment</strong>
          </h4>
        </template>

        <template v-slot:body>
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center mb-3">
              <b-form @submit.prevent="fetchData">
                <b-form-input
                  v-model="equipment.params.search"
                  style="width: 200px"
                  type="text"
                  class="mr-2"
                  placeholder="Search..."
                  @input="debouncedSearch"
                  @keyup.enter="fetchData"
                ></b-form-input>
              </b-form>
              <div style="width: 400px">
                <v-select
                  v-model="equipment.params.maintenance_component_id"
                  id="maintenance_component_id"
                  multiple
                  placeholder="Select Equipment Category"
                  label="component_name"
                  :options="categoryOpt"
                  :reduce="(opt) => opt.id"
                ></v-select>
              </div>
              <div style="width: 120px" class="mx-2">
                <v-select
                  v-model="equipment.params.active"
                  id="status"
                  placeholder="Select Status"
                  label="label"
                  :options="statusOptions"
                  :reduce="(opt) => opt.value"
                  :clearable="false"
                ></v-select>
              </div>
              <div>
                <b-button type="button" variant="primary" @click="fetchData">
                  <i class="fa fa-sliders"></i>
                  Apply Filter
                </b-button>
              </div>
            </div>
            <div class="d-flex">
              <b-button
                variant="outline-primary"
                style="height: max-content"
                class="mr-2 d-flex align-items-center"
                @click="handleExport"
              >
                <i class="ri-download-2-line pl-1"></i>
                Export
              </b-button>
              <b-button
                variant="outline-primary"
                class="d-flex align-items-center mr-2"
                style="height: max-content"
                @click="showModalImport = true"
              >
                <i class="ri-upload-2-line pl-1"></i>
                Import
              </b-button>
              <b-button
                variant="primary"
                @click="openSidebar()"
                style="height: max-content"
              >
                <i class="fa fa-plus mr-1"></i>
                New Data
              </b-button>
            </div>
          </div>

          <!-- List -->
          <div class="table-responsive">
            <table
              v-if="equipment.data?.length"
              class="table table-bordered table-striped"
            >
              <thead class="thead-light">
                <tr>
                  <th>Equipment Code</th>
                  <th>Equipment Name</th>
                  <th>Category</th>
                  <!-- <th style="width: 30%">Used For</th> -->
                  <th class="text-center">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in equipment.data" :key="index">
                  <td>{{ item.equipment_id ?? '-' }}</td>
                  <td>{{ item.equipment_name }}</td>
                  <td>{{ item.maintenance_component?.component_name }}</td>
                  <!-- <td style="width: 30%">
                    <span
                      v-for="(type, i) in item.maintenance_component
                        ?.maintenance_component_vehicle_types"
                      :key="i"
                      class="badge badge-light border mr-1"
                    >
                      {{ type?.vehicle_type?.name }}
                    </span>
                  </td> -->
                  <td align="center">
                    <span v-if="item.active" class="badge badge-primary">
                      Active
                    </span>
                    <span v-else class="badge badge-danger">In Active</span>
                  </td>
                  <td align="center">
                    <b-dropdown
                      size="sm"
                      variant="outline-primary"
                      text="Action"
                      right
                    >
                      <b-dropdown-item @click.prevent="openSidebar(item)">
                        Edit
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click.prevent="deleteItem(item)"
                        class="text-danger"
                      >
                        Delete
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="w-100 text-center py-5">
              <p class="text-muted">No Data Here!</p>
            </div>
            <div
              class="mt-4 d-flex align-items-center w-100 justify-content-end"
            >
              <b-pagination
                class="mb-0 mr-3"
                @input="fetchData"
                v-model="equipment.params.page"
                :total-rows="equipment.params.total"
                :per-page="equipment.params.limit"
                first-number
                align="center"
              ></b-pagination>
              <b-form-select
                plain
                v-model="equipment.params.limit"
                :options="limitOptions"
                style="width: 140px"
                @input="() => fetchData()"
              ></b-form-select>
            </div>
          </div>
        </template>
      </iq-card>
    </b-col>

    <!-- Custom Sidebar -->
    <custom-sidebar
      v-model="showSidebar"
      size="lg"
      :title="`${equipment.editMode ? 'Edit' : 'New'} Equipment`"
    >
      <b-form
        @submit.prevent="handleSubmit"
        class="p-4 bg-white"
        style="border-radius: 10px"
      >
        <b-form-group label="Equipment Name *" label-for="project_location">
          <b-form-input
            v-model="equipment.form.equipment_name"
            type="text"
            placeholder="Equipment Name"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Equipment Code *" label-for="project_location">
          <b-form-input
            v-model="equipment.form.equipment_id"
            type="text"
            placeholder="Equipment Code"
            required
          ></b-form-input>
        </b-form-group>
        <!-- <b-form-group label="Used For *" label-for="fleet">
          <v-select
            v-model="equipment.form.vehicle_type_ids"
            id="fleet"
            multiple
            placeholder="Select Vehicle Type"
            label="name"
            :options="typeFleet"
            :reduce="(opt) => opt.code"
          ></v-select>
        </b-form-group> -->

        <b-form-group label="Description" label-for="Description">
          <b-form-textarea
            v-model="equipment.form.description"
            id="notes"
            rows="3"
            placeholder="Description"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group
          label="Equipment Category *"
          label-for="equipment_category"
        >
          <v-select
            v-model="equipment.form.maintenance_component_id"
            label="component_name"
            placeholder="Select Equipment Category"
            :options="categoryOpt"
            :reduce="(opt) => opt.id"
          ></v-select>
        </b-form-group>

        <b-form-group label="Status *" label-for="active">
          <b-form-checkbox
            v-model="equipment.form.active"
            name="check-button"
            switch
            inline
          >
            <template v-if="equipment.form.active === false">No</template>
            <template v-else>Yes</template>
          </b-form-checkbox>
        </b-form-group>

        <hr />
        <div class="d-flex">
          <b-button
            type="button"
            variant="outline-primary"
            class="mr-3 w-50"
            @click="closeSidebar"
          >
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" class="w-50">
            {{ equipment.editMode ? 'Save' : 'Add' }}
          </b-button>
        </div>
      </b-form>
    </custom-sidebar>
  </b-row>
</template>

<script>
import { fleetsActions, pmsActions } from '@/src/Utils/helper'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import { debounce } from 'lodash'

export default {
  name: 'MasterEquipment',
  components: { CustomSidebar },
  data() {
    return {
      showModalImport: false,
      showModalImportErrors: false,
      importErrors: [],
      statusOptions: [
        { label: 'Active', value: true },
        { label: 'In Active', value: false },
      ],
      importFile: null,
      limitOptions,
      typeFleet: [],
      categoryOpt: [],
      showSidebar: false,
      equipment: {
        editMode: false,
        params: {
          search: '',
          vehicleTypeIds: [],
          active: true,
          page: 1,
          limit: 10,
          total: 10,
          totalPages: 1,
          maintenance_component_id: [],
        },
        data: [],
        form: {
          maintenance_component_id: null,
          equipment_id: null,
          equipment_name: '',
          description: '',
          vehicleTypeId: [],
          active: true,
        },
        detailData: null,
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...pmsActions,
    debouncedSearch: debounce(function () {
      this.equipment.params.page = 1 // Reset to first page when searching
      this.fetchData()
    }, 1000),
    resetFilter() {
      // Reset semua filter ke nilai default
      this.equipment.params.search = ''
      this.equipment.params.vehicleTypeIds = []
      this.equipment.params.maintenance_component_id = []
      this.equipment.params.active = true
      this.equipment.params.page = 1

      // Apply filter setelah reset
      this.fetchData()
    },
    async handleImport() {
      try {
        const formData = new FormData()
        formData.append('file', this.importFile)
        const res = await this.importEquipment(formData)
        this.$swal({
          title: 'Import Data Success',
          icon: 'success',
        })
      } catch (error) {
        console.log('Import Error:', error)
        const errorList = error?.data?.data?.errors || []
        if (errorList.length > 0) {
          this.importErrors = errorList
          this.showModalImportErrors = true
        } else {
          this.$swal({
            title: 'Failed Import Data!',
            type: 'error',
            text: 'Failed Import Data please check your file import!',
            icon: 'error',
          })
        }
      } finally {
        this.fetchData()
      }
    },
    async handleExportTemplate() {
      try {
        const res = await this.exportTemplateEquipment()
        saveAs(res.data, 'template_master_equipment.xlsx')
        this.$swal({
          title: 'Download Template Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Failed Export Template',
          icon: 'error',
        })
      }
    },
    async handleExport() {
      try {
        const res = await this.exportEquipment()
        saveAs(res.data, 'master_equipment.xlsx')
        this.$swal({
          title: 'Download Template Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Failed Export Template',
          icon: 'error',
        })
      }
    },
    openSidebar(data) {
      this.showSidebar = true
      if (data) {
        this.equipment.editMode = true
        this.equipment.detailData = data
        this.equipment.form = {
          maintenance_component_id: data.maintenance_component_id,
          equipment_id: data?.equipment_id,
          equipment_name: data?.equipment_name,
          description: data.description,
          // vehicle_type_ids:
          //   data.maintenance_component?.maintenance_component_vehicle_types?.map(
          //     (el) => el?.vehicle_type_id
          //   ),
          active: data.active,
        }
      } else {
        this.equipment.editMode = false
        this.equipment.detailData = null
        this.equipment.form = {
          maintenance_component_id: null,
          equipment_id: '',
          equipment_name: '',
          description: '',
          // vehicle_type_ids: [],
          active: true,
        }
      }
    },

    closeSidebar() {
      this.showSidebar = false
    },

    async getVehicleTypeData() {
      const res = await this.getFleetTypes()

      if (res.status === 'success' && Array.isArray(res.data)) {
        // langsung assign data yg aktif
        this.typeFleet = res.data
          .filter((item) => item.active)
          .map((element) => ({
            name: element.name,
            color:
              element.name === 'Tugboat'
                ? 'success'
                : element.name === 'Barge'
                ? 'warning'
                : 'primary',
            code: element.id,
          }))
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchData(page = 1) {
      const res = await this.getEquipment({
        ...this.equipment.params,
        page,
        vehicleTypeId: this.equipment.params.vehicleTypeIds?.toString(),
        maintenance_component_id:
          this.equipment.params.maintenance_component_id?.toString(),
      })
      if (res.status === 'success') {
        this.equipment.data = res.data.data
        this.equipment.params = {
          ...this.equipment.params,
          ...res.data.pagination,
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchDataCategory() {
      const params = {
        limit: 9999,
        page: 1,
      }
      const res = await this.getEquipmentCategory(params)
      if (res.status === 'success') {
        const filteredData = res.data.data
        console.log({ filteredData })

        this.categoryOpt = filteredData
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async handleSubmit() {
      if (this.equipment.form.maintenance_component_id) {
        this.equipment.form.maintenance_component_id = Number(
          this.equipment.form.maintenance_component_id
        )
      }

      this.$swal.fire({
        title: 'Processing...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading()
        },
      })

      if (this.equipment.editMode) {
        const res = await this.updateEquipment({
          id: this.equipment.detailData.id,
          data: this.equipment.form,
        })
        if (res.status === 'success') {
          this.$swal('Update Success!', res.data.message, 'success')
          this.fetchData()
          this.showSidebar = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      } else {
        const body = {
          ...this.equipment.form,
          alias: this.equipment.form.equipment_name
            .toLowerCase()
            .replace(' ', '_'),
        }
        const res = await this.createEquipment(body)
        if (res.status === 'success') {
          this.$swal('Add Success!', res.data.message, 'success')
          this.fetchData()
          this.showSidebar = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      }
    },

    deleteItem(dataVal) {
      this.$swal({
        title: 'Delete Equipment Category?',
        text: `${dataVal.text} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteEquipment(dataVal.id)
          if (res.status === 'success') {
            this.fetchData()
            this.$swal(
              `Deleted!`,
              `Equipment Category ${dataVal.equipment_name} successfully deleted`,
              'success'
            )
          } else {
            this.$swal('Error', res.data.message || 'Server error', 'error')
          }
        }
      })
    },
  },
  watch: {
    'equipment.form.equipment_name'(newVal) {
      // Hanya generate otomatis saat CREATE; jika EDIT, jangan ubah equipment_id
      // if (this.equipment.editMode) return

      if (!newVal) {
        this.equipment.form.equipment_id = ''
        return
      }

      // Generate ID: EQPT-DD/MM/YYYY-<INITIALS>
      // - INITIALS: hanya huruf depan dari setiap kata pada equipment_name, uppercase (contoh: "Hydraulic Pump Motor" => "HPM")
      // - Tanggal: format DD/MM/YYYY (tanggal saat ini)
      const words = (newVal || '').trim().match(/[A-Za-z0-9]+/g) || []

      const initials = words.map((w) => w.charAt(0).toUpperCase()).join('')

      const now = new Date()
      const dd = String(now.getDate()).padStart(2, '0')
      const mm = String(now.getMonth() + 1).padStart(2, '0')
      const yyyy = now.getFullYear()
      const dateStr = `${dd}${mm}${yyyy}`

      this.equipment.form.equipment_id = initials
        ? `${dateStr}-EQPT-${initials}`
        : `${dateStr}-EQPT`
    },
  },
  mounted() {
    this.getVehicleTypeData()
    this.fetchData()
    this.fetchDataCategory()
  },
}
</script>
